<template>
  <li v-if="content.show">
    <p class="">第<span class="text-label">{{content.order}}</span>:{{content.title}}</p>
    <button @click=sendAToParent(content.Anext) class="btn-blue">{{content.A}}</button>
    <button @click=sendBToParent(content.Bnext) class="btn-red">{{content.B}}</button>
  </li>
</template>
<script>
export default {
  props:{
    content: Object
  },
  methods:{
    sendAToParent(next){
        this.$emit("listenToChildEvent",next);
    },
    sendBToParent(next){
        this.$emit("listenToChildEvent",next);
    }
  }
}
</script>
<style lang="stylus" scoped>
  p
    padding:0.32rem
    background-color:#00B3DE
    font-weight:bold
    color:#ffffff
    border-radius:10px
    width: 3.8rem
    height: 1.28rem
    margin:0.32rem auto
    font-size: 0.32rem
</style>
